import * as API from '../../api';
import {getConfig} from '../../config';
import {stringIdFactory} from '../mocks';
import {emitPusherMessages} from './emitPusherMessages';
import {MemberRequest} from './types';
import {createEnhancedResourceContainer} from '../utils';

// Dummy parameters
type GetMemberRequest_QueryParameters_Dummy = {teamId: number};

const {
  component: MemberRequestLoader,
  useOperations: useMemberRequestsOperations,
  useResource: useMemberRequest,
  useResources: useMemberRequests,
} = createEnhancedResourceContainer<
  MemberRequest,
  GetMemberRequest_QueryParameters_Dummy,
  API.Components.Schemas.ApiCreateMembershipPayload
>({
  scopeKey: 'teamId',
  entityName: 'MemberRequest',
  idKey: 'clientId',
  endPoint: '/requests/v-1/teamMembers',
  mockData: [],
  mockIdFactory: stringIdFactory,
  mockHook: emitPusherMessages,
  getConfig,
});

export {
  MemberRequestLoader,
  useMemberRequestsOperations,
  useMemberRequest,
  useMemberRequests,
};
export * from './types';
